
import { Directive, HostListener, ElementRef, AfterViewInit } from '@angular/core';

/**
 * This directive helps expand textareas down when enough text is entered to need a new line
 *
 * source: https://medium.com/@chandrahasstvs/building-your-own-text-area-auto-resize-directive-in-angular-bbe3e5144e97
 */
@Directive({
  selector: '[appTextareaAutoresize]'
})
export class TextareaAutoresizeDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  @HostListener(':ngModelChange')
  onInput() {
    this.resize();
  }

  ngAfterViewInit() {
    if (this.elementRef.nativeElement.scrollHeight) {
      this.resize();
    }
  }

  resize() {
    this.elementRef.nativeElement.style.height = '0';
    this.elementRef.nativeElement.style.height = this.elementRef.nativeElement.scrollHeight + 'px';
  }
}
